import { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogTitle,
  AlertDialogTrigger,
  AlertDialogOverlay,
  AlertDialogPortal, // <--- Importante: Agregamos el Portal
} from "@radix-ui/react-alert-dialog";
import { Trash } from "lucide-react";

export default function BotonEliminar({ idServicio, onDeleteSuccess, nombreCliente }) {
  const [open, setOpen] = useState(false);

  const handleDelete = async () => {
    // Sacamos el nombre que ya confirmamos que tenés en el storage
    const nombreUsuario = localStorage.getItem("userName");
    try {
      await axios.delete(`${process.env.REACT_APP_BASE_URL}/servicio/${idServicio}`, {
        // ⚠️ En Axios DELETE, el body debe ir dentro de la propiedad 'data'
        data: { usuario_nombre: nombreUsuario }
      });

      toast.success("Servicio eliminado correctamente");
      onDeleteSuccess?.();
    } catch (error) {
      toast.error("Error al eliminar el servicio");
    } finally {
      setOpen(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        <button
          className="text-red-500 hover:text-white hover:bg-red-500 p-1.5 rounded-lg transition-all"
          title="Eliminar servicio"
        >
          <Trash size={18} />
        </button>
      </AlertDialogTrigger>

      {/* El Portal saca el modal fuera de la tabla para que nada quede "por encima" */}
      <AlertDialogPortal>
        {/* Overlay con desenfoque agresivo y z-index máximo */}
        <AlertDialogOverlay className="fixed inset-0 z-[999] bg-slate-900/40 backdrop-blur-md animate-in fade-in duration-300" />

        {/* Contenido centrado con z-index superior al overlay */}
        <AlertDialogContent className="fixed top-[50%] left-[50%] z-[1000] w-[95vw] max-w-md translate-x-[-50%] translate-y-[-50%] rounded-2xl bg-white p-8 shadow-2xl animate-in zoom-in-95 duration-300 focus:outline-none border border-slate-100">

          <div className="flex flex-col items-center text-center">
            {/* Icono de advertencia estilizado */}
            <div className="w-16 h-16 bg-red-50 text-red-500 rounded-full flex items-center justify-center mb-4 ring-8 ring-red-50/50">
              <Trash size={32} />
            </div>

            <AlertDialogTitle className="text-2xl font-black text-slate-800 mb-2">
              ¿Eliminar servicio?
            </AlertDialogTitle>

            <AlertDialogDescription className="text-slate-500 text-base mb-8 leading-relaxed">
              Esta acción es permanente. Se borrarán todos los datos y remitos asociados a <strong>{nombreCliente}</strong>.
              <span className="block mt-2 font-semibold text-red-400 text-xs uppercase">No podrás deshacer este cambio.</span>
            </AlertDialogDescription>



            <div className="flex gap-4 w-full">
              <AlertDialogCancel className="flex-1 px-6 py-3 rounded-xl bg-slate-100 text-slate-600 hover:bg-slate-200 transition-all font-bold text-sm uppercase tracking-widest">
                Cancelar
              </AlertDialogCancel>

              <AlertDialogAction
                onClick={handleDelete}
                className="flex-1 px-6 py-3 rounded-xl bg-red-600 text-white hover:bg-red-700 transition-all font-bold text-sm uppercase tracking-widest shadow-lg shadow-red-200 active:scale-95"
              >
                Confirmar
              </AlertDialogAction>
            </div>
          </div>

        </AlertDialogContent>
      </AlertDialogPortal>
    </AlertDialog>
  );
}